export default "__VITE_ASSET__PTwrIR6z__"